package es.subastia.ui.theme

import androidx.compose.ui.graphics.Color

val DarkPrimary = Color(0xFF00E5FF)
val DarkOnPrimary = Color(0xFF00363D)
val DarkPrimaryContainer = Color(0xFF004E58)
val DarkOnPrimaryContainer = Color(0xFFB2F5FF)

val DarkSecondary = Color(0xFFB0BEC5)
val DarkOnSecondary = Color(0xFF1C313A)
val DarkGradientStart = Color(0xFF0B1014)
val DarkGradientEnd = Color(0xFF1B262C)
val DarkBackground = Color(0xFF0B1014)
val DarkSurface = Color(0xFF151C24)
val DarkOnSurface = Color(0xFFECEFF1)
val DarkOutline = Color(0xFF37474F)

val LightGradientStart = Color(0xFFF0F4F8)
val LightGradientEnd = Color(0xFFFFFFFF)
val LightPrimary = Color(0xFF00677D)
val LightOnPrimary = Color(0xFFFFFFFF)
val LightBackground = Color(0xFFF8FDFF)
val LightSurface = Color(0xFFFFFFFF)
val LightOnSurface = Color(0xFF191C1D)
